import axios from "axios";

export async function addOrder({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/add", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getOrders({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getOrderById({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/id", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}

export async function getDeliveryBySerial({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/delivery-by-serial", {
      params: payload,
    });
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function getOrderBySerial({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/order-by-serial", {
      params: payload,
    });
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function getProductOrdersByIdentification({ commit }, payload) {
  try {
    const { data } = await axios.get(
      "/orders/getProductOrdersByIdentification",
      {
        params: payload,
      }
    );
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateOrder({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/update", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addDeliveryOrder({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/addDeliveryOrder", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateDeliveryOrder({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/updateDeliveryOrder", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getProducts({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getProducts", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getDeliverytOrders({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getDeliverytOrders", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateOP({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/updateOP", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addLoteToProduct({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/addLoteToProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
export async function makeSupply({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/makeSupply", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function sendNotificationLoteEvent({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/orders/sendNotificationLoteEvent",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateProduct({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/updateProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function createProduct({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/createProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function deleteProduct({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/deleteProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getEvents({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getEvents", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getProductsList({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getProductsList", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getProductsListAll({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/get-products-all", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setDateDelivery({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/setDateDelivery", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getDeliveryByDateRange({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getDeliveryByDateRange", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function createOPCopied({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/copyOP", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function createDeliveryOPCopied({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/copyDeliveryOP", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getOrderProductsByLote({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getOrderProductsByLote", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function suspendOP({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/suspendOP", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getFolioStock({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getFolioStock", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setLoteInProduct({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/setLoteInProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getProductUpdated({ commit }, payload) {
  try {
    const { data } = await axios.get("/orders/getProductUpdated", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function removeStockFromProduct({ commit }, payload) {
  try {
    const { data } = await axios.put("/orders/removeStockFromProduct", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function removeAllStockFromProduct({ commit }, payload) {
  try {
    const { data } = await axios.put(
      "/orders/removeAllStockFromProduct",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setAssignedProducts({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/setAssignedProducts", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function setWeightFormulation({ commit }, payload) {
  try {
    const { data } = await axios.post("/orders/setWeightFormulation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function deleteOrder({ commit }, payload) {
  try {
    const { data } = await axios.delete("/orders/delete-order", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    throw Error(e.response.data.message);
  }
}
